import React from 'react'
import { SVGProps } from 'react'

const CommentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M8.00002 0.400024C3.58882 0.400024 2.15004e-05 3.62989 2.15004e-05 7.60002C2.15004e-05 8.98776 0.438955 10.332 1.27149 11.4944C1.11389 13.2376 0.691488 14.5318 0.0781548 15.1448C-0.00291183 15.2259 -0.0231785 15.3499 0.0280215 15.4523C0.0733548 15.5438 0.166688 15.6 0.266688 15.6C0.278955 15.6 0.291221 15.5992 0.303755 15.5974C0.411755 15.5822 2.92055 15.2211 4.73522 14.1736C5.76562 14.5894 6.86322 14.8 8.00002 14.8C12.4112 14.8 16 11.5702 16 7.60002C16 3.62989 12.4112 0.400024 8.00002 0.400024ZM4.26669 8.66669C3.67842 8.66669 3.20002 8.18829 3.20002 7.60002C3.20002 7.01176 3.67842 6.53336 4.26669 6.53336C4.85495 6.53336 5.33335 7.01176 5.33335 7.60002C5.33335 8.18829 4.85495 8.66669 4.26669 8.66669ZM8.00002 8.66669C7.41175 8.66669 6.93335 8.18829 6.93335 7.60002C6.93335 7.01176 7.41175 6.53336 8.00002 6.53336C8.58829 6.53336 9.06669 7.01176 9.06669 7.60002C9.06669 8.18829 8.58829 8.66669 8.00002 8.66669ZM11.7334 8.66669C11.1451 8.66669 10.6667 8.18829 10.6667 7.60002C10.6667 7.01176 11.1451 6.53336 11.7334 6.53336C12.3216 6.53336 12.8 7.01176 12.8 7.60002C12.8 8.18829 12.3216 8.66669 11.7334 8.66669Z" />
    </g>
  </svg>
)
export default CommentIcon
